import { render } from "./dpw-card.vue?vue&type=template&id=7ba90b0a&scoped=true"
import script from "./dpw-card.vue?vue&type=script&lang=js"
export * from "./dpw-card.vue?vue&type=script&lang=js"

import "./dpw-card.vue?vue&type=style&index=0&id=7ba90b0a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba90b0a"]])

export default __exports__